import { Language } from "../../constants/language";
import { Ministry } from "../../models/ministry/ministry";
import {PaginatedResult, PaginationUtil} from "../../utils/pagination-util";
import {
	HARVEST_MEDIA_EN, HARVEST_MEDIA_AR,
	JUBILEE_MEDIA_EN, JUBILEE_MEDIA_AR,
	JOURNEY_MEDIA_EN, JOURNEY_MEDIA_AR,
	YOUTH_MEDIA_EN, YOUTH_MEDIA_AR,
	GOODNESS_MERCY_MEDIA_EN, GOODNESS_MERCY_MEDIA_AR,
	EVANGELISM_MEDIA_EN, EVANGELISM_MEDIA_AR
} from "./ministry-media-data";
import {COMMON_FORM_MOCK_DATA_EN, COMMON_FORM_MOCK_DATA_AR} from "../form-mock-data";
import {
	EMMANUEL_HOUSE_EN, EMMANUEL_HOUSE_AR,
	KASR_EL_DOBARA_EN, KASR_EL_DOBARA_AR
} from "../address/addresses-data";

export enum MINISTRY_ID {
	SEVEN_WEEKS_HARVEST = 1,
	JUBILEE_PROGRAM = 2,
	JOURNEY_DISCIPLESHIP = 3,
	CHOSEN_GENERATION_YOUTH = 4,
	GOODNESS_AND_MERCY = 5,
	EVANGELISM_SECTOR = 6
}


const SEVEN_WEEKS_HARVEST_ENROLLMENT_FORM = "https://docs.google.com/forms/d/1beJEj6tClwSKmPFxnNz7-67O-xxVxB--3ouJD3aU5Tc/edit?usp=drivesdk";

const JOURNEY_ENROLLMENT_FORM = "https://docs.google.com/forms/d/e/1FAIpQLSfBk_9TErQEWohnARXOidzUb3UZRpopBCbX_eYjQbkw6K25Rg/viewform?usp=sf_link";

const MINISTRY_MOCK_DATA_EN: Ministry[] = [
	/**********************
	 * 7 Weeks Harvest Program
	 **********************/
	{
		id: MINISTRY_ID.SEVEN_WEEKS_HARVEST,
		key:"harvest",
		title: "Harvest Program – 7 Weeks",
		duration: "7 Weeks",
		description: "”Heal the sick, raise the dead, cleanse those who have leprosy,[a] drive out demons. Freely you have received; freely give.” (Matthew 10:8)",
		issues: [
			"Unexplained physical ailments",
			"Sadness, depression, anxiety, repeated failures",
			"Feelings of rejection, heavy pasts"
		],
		includes: [
			"Clear biblical teaching",
			"Deliverance and healing sessions",
			"In-depth spiritual counseling",
			"Personal and prophetic prayer"
		],
		media: HARVEST_MEDIA_EN,
		form: COMMON_FORM_MOCK_DATA_EN['program'],
		quote:"It helps you press forward in faith toward the fullness of your salvation, living in the freedom Christ has given you, and experiencing God’s healing power in every area of your life—spirit, soul, and body.",
		vision:"“Heal the sick, cleanse the lepers, raise the dead, cast out demons. Freely you have received; freely give.”— Matthew 10:8Our faith is that the secret of true power is abiding in God’s presence, and that genuine, active love is the foundation of real transformation. Therefore, we seek to present a living, practical model of Christ’s love and of the work and power of the Holy Spirit. Our ultimate and primary authority is the Word of God.",
		goal:"Our goal is to proclaim the salvation of Christ throughout all the earth and to make Jesus known more and more until He comes. We seek to bring heaven here on earth by doing what Jesus did. Therefore, we walk as Jesus walked, we destroy the works of the devil, and we proclaim the healing of Jesus everywhere.We believe in the power of the cross of our Lord Jesus Christ and in the power of His resurrection from the dead. And we believe that the same Spirit of Jesus who raised Him from the dead is the One who is at work within us.",
		mission:"Our mission is to reach all nations with the Gospel and to equip believers to encounter God personally, using the proclamation of truth along with the demonstration of the Spirit and power.",
		category: "Faith",
		address: EMMANUEL_HOUSE_EN,
		time: "Sundays 6:00 PM - 9:30 PM",
		notes: "7-week intensive program. Registration required. Includes workbook and materials.",
		hasDuration: true,
		hasEnrollment: true,
		enrollmentForm: SEVEN_WEEKS_HARVEST_ENROLLMENT_FORM,
		currentRound: 9,
		nextRoundStartDate: "February",
		nextRoundEndDate: "May 3, 2025",
		additionalInfo: "Experience profound breakthrough from generational patterns, emotional wounds, and spiritual bondages through Christ-centered healing ministry. This transformative program combines biblical truth with practical application, creating safe small group environments where participants find freedom from past traumas, destructive thought patterns, and limiting beliefs. Our trained counselors provide personalized care while the Holy Spirit brings deep inner healing. Participants often report miraculous physical healings, restored relationships, renewed purpose, and authentic joy. The program includes comprehensive workbooks, ongoing prayer support, and follow-up resources to ensure lasting transformation and continued spiritual growth in your walk with Jesus Christ.",
		isActive: true,
		socialMedia: {
			facebook: "https://www.facebook.com/profile.php?id=61559691233974"
		}
	},
	/**********************
	 * Jubilee Program
	 **********************/
	{
		id: MINISTRY_ID.JUBILEE_PROGRAM,
		key: "jubilee",
		title: "Jubilee Program",
		description: "Jubilee is a time of freedom… designed for those suffering from psychological disorders or painful emotions affecting their daily life. Through two aspects:",
		aspects: [
			"Psychological: Understanding the roots.",
			"Spiritual: Offering true healing."
		],
		includes: [
			"Skills to manage thoughts and emotions",
			"Correcting misconceptions about self and God",
			"Training on freedom and identity"
		],
		media: JUBILEE_MEDIA_EN,
		form: COMMON_FORM_MOCK_DATA_EN['program'],
		category: "Faith",
		address: KASR_EL_DOBARA_EN,
		time: "Wednesdays 7:00 PM - 9:00 PM",
		notes: "Open to all ages. Individual and group sessions available. Professional counseling approach.",
		hasDuration: true,
		hasEnrollment: false,
		currentRound: 2,
		nextRoundStartDate: "March 8, 2025",
		nextRoundEndDate: "April 26, 2025",
		additionalInfo: "Step into true freedom through our comprehensive Jubilee Program, where psychological understanding meets spiritual healing power. This transformative ministry addresses deep-rooted emotional patterns, anxiety disorders, depression, and trauma through Christ-centered counseling and biblical truth. Our trained counselors work alongside the Holy Spirit to bring breakthrough from mental bondages, negative thought cycles, and emotional pain that has held you captive. Participants discover their true identity in Christ, learn practical coping strategies, and experience supernatural peace that surpasses understanding. The program combines professional psychological insights with powerful spiritual intervention, creating safe spaces for vulnerable sharing and miraculous healing. Many participants report complete freedom from anxiety, restored joy, renewed relationships, and authentic confidence. Join this life-changing journey and experience the jubilee freedom that Jesus promised - where broken hearts are healed and captives are set completely free.",
		isActive: false
	},
	/**********************
	 * Journey - Discipleship Groups
	 **********************/
	{
		id: MINISTRY_ID.JOURNEY_DISCIPLESHIP,
		key: "journey",
		title: "\"Journey\" Discipleship Groups",
		description: "A year-long journey for both new and advanced believers, building a strong personal relationship with the Lord.",
		includes: [
			"Biblical teaching and practical application",
			"Continuous personal care",
			"Training for service and leadership",
			"Establishing a true biblical identity"
		],
		quote: "Discipleship is not just about attending meetings or listening to words…\nIt is a daily journey with Christ, where we live out His Word and learn how to think, act, and love the way He does.",
		vision: "\"But we all, with unveiled face, beholding as in a mirror the glory of the Lord, are being transformed into the same image from glory to glory, just as by the Spirit of the Lord.\"\n(2 Corinthians 3:18)\n\nWe believe that discipleship is not a program or a temporary activity, but a way of life and a calling to walk with Jesus day after day.\nOur vision is to see people renewed in their minds, grounded in their identity in Christ, able to live out the Gospel practically and to make other disciples in turn.\n\nWe also seek to build young people who live in a real relationship with God, understand His purpose for their lives, and see their walk with Him transformed from mere spiritual attendance into a fruitful and impactful life among others.",
		goal: "Our goal is to walk with young people on a journey of spiritual growth and holistic maturity through:\n\nEstablishing a healthy foundation of faith built on the Word of God\n\nRenewing the mind and understanding true identity in Christ\n\nPracticing discipleship that touches daily life, not just intellectual knowledge\n\nProviding a safe environment for sharing, questioning, growth, and healing\n\nPreparing servants and leaders who live what they learn and pass it on to others\n\nWe believe that true change begins from within, and that God works in the journey of discipleship step by step—\nby grace, not pressure; by love, not condemnation.",
		mission: "Our mission is to walk together on the path of discipleship, learning from Jesus, open to the work of the Holy Spirit, and responsive to God's call for our lives.\nWe are here to support, accompany, and encourage every person to live out the fullness of the calling they were created for.",
		media: JOURNEY_MEDIA_EN,
		form: COMMON_FORM_MOCK_DATA_EN['program'],
		category: "Faith",
		address: EMMANUEL_HOUSE_EN,
		time: "Sundays 5:00 PM - 6:30 PM",
		notes: "12-month commitment. Small group setting (8-12 people). Includes study materials and mentorship.",
		hasDuration: false,
		hasEnrollment: true,
		enrollmentForm: JOURNEY_ENROLLMENT_FORM,
		additionalInfo: "Embark on a transformative year-long journey of deep discipleship that builds authentic relationship with Jesus Christ. Our Journey Discipleship Groups provide comprehensive spiritual formation for both new believers discovering their faith and seasoned Christians seeking deeper growth. Through systematic biblical teaching, practical application exercises, and continuous pastoral care, participants develop strong spiritual foundations and mature Christian character. The program emphasizes personal mentorship, accountability partnerships, and hands-on ministry training that prepares you for effective kingdom service. Small group dynamics foster authentic community while individual attention ensures personalized growth. Participants engage in regular scripture study, prayer disciplines, service projects, and leadership development opportunities. Many graduates become ministry leaders, church planters, and kingdom ambassadors. This intensive program creates lasting spiritual transformation, authentic Christian identity, and lifelong relationships with fellow believers. Join this extraordinary journey where ordinary people become extraordinary disciples equipped to impact their world for Christ.",
		isActive: true,
		socialMedia: {
			facebook: "https://www.facebook.com/JourneyZoe"
		}
	},
	/**********************
	 * Youth Meeting - Chosen Generation
	 **********************/
	{
		id: MINISTRY_ID.CHOSEN_GENERATION_YOUTH,
		key: "youth",
		title: "Youth Meeting – Chosen Generation",
		description: "A weekly meeting for the youth of this generation, featuring prophetic worship, anointed preaching, and a touch of the Holy Spirit.",
		vision: "A chosen generation, filled with the fire of God, impacting everywhere.",
		quote: "Youth are not just a future generation… they are a present force. When they understand their identity and live their calling, they can revive a nation. Youth are the heartbeat of the church and the voice of the future. When their hearts are set on fire by the love of Christ, they become moving flames, changing the world around them.",
		includes: [
			"Prophetic worship and intercession",
			"Anointed biblical teaching",
			"Youth leadership development",
			"Supernatural encounters with God"
		],
		media: YOUTH_MEDIA_EN,
		category: "Faith",
		address: EMMANUEL_HOUSE_EN,
		time: "Tuesdays 6:30 PM - 9:30 PM",
		notes: "Worship and teaching. Special events and retreats throughout the year.",
		hasDuration: false,
		hasEnrollment: false,
		additionalInfo: "Ignite your generation through powerful encounters with God at our dynamic Chosen Generation youth meetings. This high-energy weekly gathering combines prophetic worship, anointed preaching, and supernatural encounters designed specifically for young hearts hungry for authentic spiritual experience. Our passionate youth leaders create an atmosphere where teenagers and young adults encounter God's presence, discover their prophetic calling, and develop kingdom identity. Through inspiring worship sessions, relevant biblical teaching, interactive prayer experiences, and peer ministry opportunities, participants develop strong spiritual foundations and radical faith. The ministry emphasizes prophetic gifts, worship excellence, evangelistic passion, and social justice engagement. Regular special events include worship nights, retreat weekends, mission trips, and community outreach projects. Many young people experience miraculous healings, receive divine direction, develop leadership skills, and launch into full-time ministry. This isn't just another youth program - it's a supernatural breeding ground for the next generation of world-changers, revivalists, and kingdom leaders who will transform nations through God's power.",
		isActive: true,
		socialMedia: {
			facebook: "https://www.facebook.com/thechosengeneration4youth/",
			instagram: "https://www.instagram.com/thechosengeneration4youth/",
			whatsapp: "https://chat.whatsapp.com/IBWkXlvJQrxFEWF3q5ds9y"
		}
	},
	/**********************
	 * Goodness and Mercy
	 **********************/
	{
		id: MINISTRY_ID.GOODNESS_AND_MERCY,
		key: "goodness-mercy",
		title: "\"Goodness and Mercy\" Program",
		description: "A practical ministry that extends Christ's love to those in need.",
		includes: [
			"Material and emotional support for widows, orphans, and the sick",
			"Regular field visits",
			"Connecting them to healing and discipleship programs within the ministry"
		],
		quote: "Helping the needy is not just giving… it is a practical declaration of the Father's heart. When we reach the broken, we become the hands of Jesus extended for healing and hope. Helping the needy is serving Christ Himself. The needy are not numbers… they are treasures in the eyes of God.",
		media: GOODNESS_MERCY_MEDIA_EN,
		category: "Faith",
		address: KASR_EL_DOBARA_EN,
		time: "Saturdays 9:00 AM - 1:00 PM",
		notes: "Community service and outreach. Volunteers welcome. Monthly distribution events.",
		hasDuration: false,
		hasEnrollment: false,
		additionalInfo: "Experience the heart of Christ through practical service to those in need. Our Goodness and Mercy ministry embodies the compassionate love of Jesus by extending hope, healing, and practical support to widows, orphans, the sick, and marginalized communities. Through regular field visits, food distributions, medical assistance, and emotional support, we demonstrate God's unfailing love in tangible ways. Our dedicated teams build meaningful relationships with those we serve, providing not just material aid but spiritual encouragement and connection to life-changing programs within our ministry. Volunteers receive training in compassionate care, prayer ministry, and practical service skills. Many participants discover their calling to serve others and develop hearts of mercy that reflect Christ's character. This ministry creates bridges between the church and community, opening doors for evangelism, discipleship, and lasting transformation. Join us as we become the hands and feet of Jesus, bringing His goodness and mercy to those who need it most.",
		isActive: true
	},
	/**********************
	 * Evangelism Sector - "Light to the World"
	 **********************/
	{
		id: MINISTRY_ID.EVANGELISM_SECTOR,
		key: "evangelism",
		title: "Evangelism Sector – \"Light to the World\"",
		description: "Evangelism in Zoe is not just an activity… it is the essence of our calling. Our heart is that every soul comes to know Jesus and tastes the divine life. We go out to the streets, serve in open spaces, pray with people, and testify of Christ.",
		includes: [
			"Trained evangelistic teams",
			"Field and seasonal evangelism",
			"Digital evangelism via the internet",
			"Booklets, Bibles, and content filled with hope"
		],
		quote: "We are here to break the darkness… and declare the light.",
		media: EVANGELISM_MEDIA_EN,
		form: COMMON_FORM_MOCK_DATA_EN['sevenWeeks'],
		category: "Faith",
		address: EMMANUEL_HOUSE_EN,
		time: "3rd Friday of every month, 10:00 AM - 2:00 PM",
		notes: "Active evangelism programs. Training provided. Multilingual outreach available.",
		hasDuration: false,
		hasEnrollment: false,
		additionalInfo: "Join the frontlines of kingdom advancement through our dynamic Evangelism Sector, where passionate believers become powerful witnesses bringing light to dark places. This ministry combines strategic street evangelism with innovative digital outreach to reach souls across all demographics and platforms. Our trained evangelistic teams operate with supernatural boldness, equipped with healing anointing, prophetic insights, and compelling testimonies that break through hardened hearts. Through systematic training programs, participants learn effective witnessing techniques, apologetics, cross-cultural evangelism, and supernatural ministry operation. The ministry provides comprehensive resources including gospel literature, digital content, follow-up materials, and connection pathways to discipleship programs. Regular outreach events target universities, markets, parks, and online communities where lost souls desperately need hope. Our multilingual approach ensures no language barrier prevents the gospel message from reaching receptive hearts. Many team members experience miraculous breakthroughs, divine appointments, and supernatural encounters while witnessing. This isn't just soul-winning - it's spiritual warfare against darkness, territorial breakthrough for communities, and harvest preparation for the great revival that's coming upon the earth.",
		isActive: true
	}
];


const MINISTRY_MOCK_DATA_AR: Ministry[] = [
	/**********************
	 * برنامج الحصاد 7 أسابيع
	 **********************/
	{
		id: 1,
		key:"harvest",
		title: "برنامح \"الحصاد\" - 7 أسابيع",
		duration: "7 أسابيع",
		description: "“اِشْفُوا مَرْضَى. طَهِّرُوا بُرْصًا. أَقِيمُوا مَوْتَى. أَخْرِجُوا شَيَاطِينَ. مَجَّانًا أَخَذْتُمْ، مَجَّانًا أَعْطُوا.“ (مت 10: 8)",
		issues: [
			"أمراض جسدية مش مفسّرة",
			"حزن، اكتئاب، قلق، فشل متكرر",
			"مشاعر رفض، وماضي تقيل"
		],
		includes: [
			"تعليم كتابي واضح",
			"جلسات تحرير وشفاء",
			"مشورة روحية معمّقة",
			"صلاة نبوية وشخصية"
		],
		media: HARVEST_MEDIA_AR,
		form: COMMON_FORM_MOCK_DATA_AR['sevenWeeks'],
		category: "الإيمان",
		address: EMMANUEL_HOUSE_AR,
		time: "الاحد 6:00 - 9:30 مساءً",
		notes: "برنامج مكثف لمدة 7 أسابيع. التسجيل مطلوب. يشمل كتيب العمل والمواد.",
		hasDuration: true,
		hasEnrollment: true,
		quote:"يساعدك على التقدم بقوة تجاه تميم خلاصك واختبار حياة الحرية والشفاء الالهى فى كل جانب من جوانب حياتك روحياً ونفسياً وجسدياً",
		vision:" ”اِشْفُوا مَرْضَى. طَهِّرُوا بُرْصًا. أَقِيمُوا مَوْتَى. أَخْرِجُوا شَيَاطِينَ. مَجَّانًا أَخَذْتُمْ، مَجَّانًا أَعْطُوا.“ مَتَّى 10:8	ايماننا ان سر القوة الحقيقية هو وجودنا فى الحضور الالهى وان المحبةالحقيقية الفاعلة هى اساس التغير ، و نسعى لانن نقدم نموذج عملى لمحبةالمسيح وعمل وقوة الروح القدس و مرجعيتنا الاساسية هى كلمة الله",
		goal:"هدفنا هو ان نعلن خلاص المسيح فى كل الارض ، وان نجعل يسوع معروفااكثر واكثر الى ان يأتى ، و ان نحضر السماء هنا عالارض عن طريق فعل ما فعله يسوع ، لذا نحن نسلك مثلما يسوع سلك و ننقض اعمال ابليس ونعلن شفاءيسوع فى كل مكان فنحن نؤمن بقوة صليب الرب يسوع المسيح وقوة قيامتة من الاموات وان روحيسوع الذى اقامة من الاموات هو الذى يعمل فينا ",
		mission:"رسالتنا هى الوصول بالانجيل لكل الامم وتمكين المخلصين من الوصولللختبار حقيقى مع الله مستخدمين الاعلان فى الحق وبرهان الروح والقوة",
		currentRound: 9,
		nextRoundStartDate: "فبراير",
		nextRoundEndDate: "3 مايو 2025",
		additionalInfo: "اختبر اختراقاً عميقاً من الأنماط الجيلية والجروح العاطفية والقيود الروحية من خلال خدمة الشفاء المتمركزة حول المسيح. يجمع هذا البرنامج التحويلي بين الحق الكتابي والتطبيق العملي، مما يخلق بيئات مجموعات صغيرة آمنة حيث يجد المشاركون الحرية من الصدمات السابقة وأنماط التفكير المدمرة والمعتقدات المحدودة. يقدم مستشارونا المدربون رعاية شخصية بينما يجلب الروح القدس شفاءً داخلياً عميقاً. كثيراً ما يبلغ المشاركون عن شفاءات جسدية معجزية وعلاقات مستعادة وهدف متجدد وفرح حقيقي.",
		isActive: true,
		enrollmentForm: SEVEN_WEEKS_HARVEST_ENROLLMENT_FORM,
		socialMedia: {
			facebook: "https://www.facebook.com/profile.php?id=61559691233974"
		}
	},
	/**********************
	 * برنامج اليوبيل
	 **********************/
	{
		id: 2,
		key: "jubilee",
		title: "برنامج \"يوبيل\"",
		description: "يوبيل هو زمن العتق… وبرنامج يوبيل معمول خصيصًا للي بيعانوا من اضطرابات نفسية أو مشاعر مؤلمة مأثرة على حياتهم اليومية. من خلال شقين:",
		aspects: [
			"نفسي: بنفهم الجذور",
			"روحي: بنقدم الشفاء الحقيقي"
		],
		includes: [
			"مهارات لإدارة الأفكار والمشاعر",
			"تصحيح مفاهيم عن النفس والله",
			"تدريب على الحرية والهوية"
		],
		media: JUBILEE_MEDIA_AR,
		form: COMMON_FORM_MOCK_DATA_AR['sevenWeeks'],
		category: "الإيمان",
		address: KASR_EL_DOBARA_AR,
		time: "الأربعاء 7:00 - 9:00 مساءً",
		notes: "مفتوح لجميع الأعمار. جلسات فردية وجماعية متاحة. نهج الاستشارة المهنية.",
		hasDuration: true,
		hasEnrollment: false,
		currentRound: 2,
		nextRoundStartDate: "8 مارس 2025",
		nextRoundEndDate: "26 أبريل 2025",
		additionalInfo: "ادخل إلى الحرية الحقيقية من خلال برنامج اليوبيل الشامل، حيث يلتقي الفهم النفسي بقوة الشفاء الروحية. تتناول هذه الخدمة التحويلية الأنماط العاطفية المتجذرة واضطرابات القلق والاكتئاب والصدمات من خلال الاستشارة المتمركزة حول المسيح والحق الكتابي. يعمل مستشارونا المدربون جنباً إلى جنب مع الروح القدس لجلب اختراق من القيود العقلية ودورات الأفكار السلبية والألم العاطفي الذي احتجزك. يكتشف المشاركون هويتهم الحقيقية في المسيح ويتعلمون استراتيجيات المواجهة العملية ويختبرون السلام الفائق الطبيعي الذي يفوق كل فهم.",
		isActive: false
	},
	/**********************
	 * رحلة - مجموعات التلمذة
	 **********************/
	{
		id: 3,
		key: "journey",
		title: "مجموعات \"رحلة\" للتلمذة",
		description: "وَنَحْنُ جَمِيعًا نَاظِرِينَ مَجْدَ الرَّبِّ بِوَجْهٍ مَكْشُوفٍ، كَمَا في مِرْآةٍ، نَتَغَيَّرُ إِلَى تِلْكَ الصُّورَةِ عَيْنِهَا، مِنْ مَجْدٍ إِلَى مَجْدٍ، كَمَا مِنَ الرَّبِّ الرُّوحِ. (2 كو 3: 18).",
		includes: [
			"تأسيس إيماني صحي مبني على كلمة الله",
			"تجديد الذهن وفهم الهوية الحقيقية في المسيح",
			"التلمذة العملية اللي بتمس الحياة اليومية، مش المعرفة العقلية بس",
			"نوفر بيئة آمنة للمشاركة، السؤال، النمو، والشفاء",
			"نعد خدام وقادة يعيشوا اللي بيتعلموه وينقلوه للآخرين"
		],
		quote: "التلمذة مش مجرد حضور أو سماع كلام…هي رحلة يومية مع المسيح، نعيش فيها كلمته، ونتعلم ازاي نفكر، نتصرف، ونحب زيه.",
		vision: "وَنَحْنُ جَمِيعًا نَاظِرِينَ مَجْدَ الرَّبِّ بِوَجْهٍ مَكْشُوفٍ، كَمَا في مِرْآةٍ، نَتَغَيَّرُ إِلَى تِلْكَ الصُّورَةِ عَيْنِهَا، مِنْ مَجْدٍ إِلَى مَجْدٍ، كَمَا مِنَ الرَّبِّ الرُّوحِ.\" (2 كو 3: 18).\n\nاحنا بنؤمن أن التلمذة مش برنامج أو نشاط مؤقت، لكن أسلوب حياة ودعوة للسير مع يسوع يوم بعد يوم.\nرؤيتنا أن نشوف أشخاص متجددين في أذهانهم، ثابتين في هويتهم في المسيح، قادرين أنهم يعيشوا الإنجيل عمليًا ويصنعوا تلاميذ آخرين بدورهم.\n\nكمان بنسعى لبناء شباب بيعيشوا علاقة حقيقية مع الله، يفهموا قصد الله لحياتهم، وتتحول علاقتهم مع ربنا من مجرد حضور روحي لحياة مثمرة ومؤثرة في وسط الناس.\n⸻",
		goal: "هدفنا هو اننا نمشي مع الشباب رحلة نمو روحي ونضج متكامل، من خلال:\n\t•\tتأسيس إيماني صحي مبني على كلمة الله\n\t•\tتجديد الذهن وفهم الهوية الحقيقية في المسيح\n\t•\tالتلمذة العملية اللي بتمس الحياة اليومية، مش المعرفة العقلية بس\n\t•\tنوفر بيئة آمنة للمشاركة، السؤال، النمو، والشفاء\n\t•\tنعد خدام وقادة يعيشوا اللي بيتعلموه وينقلوه للآخرين",
		mission: "رسالتنا هي أننا نمشي سوا في طريق التلمذة، بنتعلم من يسوع، منفتحين لعمل الروح القدس، ومتجاوبين مع دعوة ربنا لحياتنا.\nاحنا هنا علشان ندعم، نرافق، ونشجع كل شخص أن يعيش ملء الدعوة اللي خُلق لأجلها",
		media: JOURNEY_MEDIA_AR,
		form: COMMON_FORM_MOCK_DATA_AR['sevenWeeks'],
		category: "الإيمان",
		address: EMMANUEL_HOUSE_AR,
		enrollmentForm: JOURNEY_ENROLLMENT_FORM,
		time: "الأحد 5:00 - 6:30 مساءً",
		notes: "التزام لمدة 12 شهر. بيئة مجموعة صغيرة (8-12 شخص). يشمل مواد الدراسة والإرشاد.",
		hasDuration: true,
		hasEnrollment: true,
		additionalInfo: "حنا بنؤمن أن التلمذة مش برنامج أو نشاط مؤقت، لكن أسلوب حياة ودعوة للسير مع يسوع يوم بعد يوم.رؤيتنا أن نشوف أشخاص متجددين في أذهانهم، ثابتين في هويتهم في المسيح، قادرين أنهم يعيشوا الإنجيل عمليًا ويصنعوا تلاميذ آخرين بدورهم.كمان بنسعى لبناء شباب بيعيشوا علاقة حقيقية مع الله، يفهموا قصد الله لحياتهم، وتتحول علاقتهم مع ربنا من مجرد حضور روحي لحياة مثمرة ومؤثرة في وسط الناس.\n يماننا أن التغيير الحقيقي بيبدأ من الداخل، وأن الله بيعمل في رحلة التلمذة خطوة بخطوة، بنعمة مش بضغط، بمحبة مش بإدانة.",
		isActive: true,
		socialMedia: {
			facebook: "https://www.facebook.com/JourneyZoe"
		}
	},
	/**********************
	 * اجتماع الشباب - تشوزين
	 **********************/
	{
		id: 4,
		key: "youth",
		title: "اجتماع الشباب - تشوزين",
		description: "اجتماع أسبوعي لشباب هذا الجيل، يتميز بالعبادة النبوية والوعظ المسحة ولمسة الروح القدس.",
		vision: "جيل مختار، مملوء بنار الله، مؤثر في كل مكان.",
		quote: "الشباب ليسوا مجرد جيل المستقبل... إنهم قوة الحاضر. عندما يفهمون هويتهم ويعيشون دعوتهم، يمكنهم إحياء أمة. الشباب هم نبضة الكنيسة وصوت المستقبل. عندما تشتعل قلوبهم بمحبة المسيح، يصبحون ألسنة نار متحركة، تغير العالم من حولهم.",
		includes: [
			"العبادة النبوية والشفاعة",
			"التعليم الكتابي المسحة",
			"تطوير قيادة الشباب",
			"لقاءات فائقة الطبيعة مع الله"
		],
		media: YOUTH_MEDIA_AR,
		category: "الإيمان",
		address: EMMANUEL_HOUSE_AR,
		time: "الثلاثاء 6:30 - 9:30 مساءً",
		notes: "عبادة وتعليم .فعاليات خاصة ومعسكرات طوال العام.",
		hasDuration: false,
		hasEnrollment: false,
		additionalInfo: "أشعل جيلك من خلال لقاءات قوية مع الله في اجتماعات تشوزين الديناميكية للشباب. هذا التجمع الأسبوعي عالي الطاقة يجمع بين العبادة النبوية والوعظ المسحة واللقاءات الفائقة الطبيعة المصممة خصيصاً للقلوب الشابة الجائعة للاختبار الروحي الأصيل. يقود هذا الوزارة القادة الشباب المتحمسون الذين يخلقون جواً حيث يلتقي المراهقون والشباب البالغون مع حضور الله، ويكتشفون دعوتهم النبوية، ويطورون هويتهم الملكوتية. من خلال جلسات العبادة الملهمة، والتعليم الكتابي ذي الصلة، وتجارب الصلاة التفاعلية، وفرص الخدمة بين الأقران، يطور المشاركون أسساً روحية قوية وإيماناً جذرياً. تركز الوزارة على المواهب النبوية، والتفوق في العبادة، والشغف التبشيري، والانخراط في العدالة الاجتماعية. تشمل الفعاليات الخاصة المنتظمة ليالي العبادة، وعطلات نهاية الأسبوع التراجعية، ورحلات البعثات، ومشاريع الخدمة المجتمعية. يختبر العديد من الشباب شفاءات معجزية، ويتلقون توجيهاً إلهياً، ويطورون مهارات القيادة، وينطلقون في الخدمة بدوام كامل. هذه ليست مجرد برنامج شبابي آخر - إنها أرض خصبة خارقة للعادة للجيل القادم من صانعي التغيير في العالم، والمجددين، وقادة الملكوت الذين سيحولون الأمم من خلال قوة الله.",
		isActive: true,
		socialMedia: {
			facebook: "https://www.facebook.com/thechosengeneration4youth/",
			instagram: "https://www.instagram.com/thechosengeneration4youth/",
			whatsapp: "https://chat.whatsapp.com/IBWkXlvJQrxFEWF3q5ds9y"
		}
	},
	/**********************
	 * الخير والرحمة
	 **********************/
	{
		id: 5,
		key: "goodness-mercy",
		title: "خير والرحمة",
		description: "خدمة عملية للمجتمع، بتوصل محبة المسيح للناس اللي محتاجينها فعلًا.",
		includes: [
			"دعم مادي ومعنوي للأرامل والأيتام والمرضى",
			"زيارات ميدانية دورية",
			"ربطهم ببرامج الشفاء والتلمذة داخل الخدمة"
		],
		quote: "مساعدة المحتاجين مش مجرد عطاء… دي إعلان عملي عن قلب الآب. لما نوصل للمكسورين، بنكون إيدين يسوع الممتدة للشفاء والرجاء. لما نخدم المحتاج، إحنا بنخدم المسيح نفسه. المحتاج مش رقم… هو كنز في عينين الله.",
		media: GOODNESS_MERCY_MEDIA_AR,
		category: "الإيمان",
		address: KASR_EL_DOBARA_AR,
		time: "السبت 9:00 صباحاً - 1:00 ظهراً",
		notes: "خدمة مجتمعية وتوعوية. المتطوعون مرحب بهم. فعاليات توزيع شهرية.",
		hasDuration: false,
		hasEnrollment: false,
		additionalInfo: "اختبر قلب المسيح من خلال الخدمة العملية للمحتاجين. تجسد خدمة الخير والرحمة محبة يسوع الرحيمة من خلال تقديم الرجاء والشفاء والدعم العملي للأرامل والأيتام والمرضى والمجتمعات المهمشة. من خلال الزيارات الميدانية المنتظمة، وتوزيع الطعام، والمساعدة الطبية، والدعم العاطفي، نظهر محبة الله الثابتة بطرق ملموسة. تبني فرقنا المخلصة علاقات ذات مغزى مع أولئك الذين نخدمهم، ولا نقدم فقط المساعدة المادية ولكن أيضاً التشجيع الروحي والاتصال ببرامج تغيير الحياة داخل خدمتنا. يحصل المتطوعون على التدريب في الرعاية الرحيمة وخدمة الصلاة ومهارات الخدمة العملية. يكتشف العديد من المشاركين دعوتهم لخدمة الآخرين ويطورون قلوب الرحمة التي تعكس شخصية المسيح. تخلق هذه الخدمة جسوراً بين الكنيسة والمجتمع، وتفتح أبواباً للكرازة والتلمذة والتحول الدائم. انضم إلينا بينما نصبح يدي ورجلي يسوع، نجلب خيره ورحمته لأولئك الذين يحتاجون إليه أكثر من غيرهم.",
		isActive: true
	},
	/**********************
	 * قطاع الكرازة - "نور للعالم"
	 **********************/
	{
		id: 6,
		key: "evangelism",
		title: "قطاع الكرازة – \"نور للعالم\"",
		description: "الكرازة في زوي مش نشاط… لكنها جوهر الدعوة. قلبنا إن كل نفس تعرف يسوع، وتدوق الحياة الإلهية. بننزل الشوارع، بنخدم في الأماكن المفتوحة، بنصلي مع الناس، وبنشهد ليهم عن المسيح.",
		includes: [
			"فرق كرازية مدربة",
			"كرازة ميدانية وموسمية",
			"كرازة رقمية عبر الإنترنت",
			"كتيبات، إنجيل، ومحتوى محمّل بالرجاء"
		],
		quote: "إحنا هنا علشان نكسر الظلمة… ونعلن النور.",
		media: EVANGELISM_MEDIA_AR,
		category: "الإيمان",
		address: EMMANUEL_HOUSE_AR,
		time: "الجمعة الثالثة من كل شهر، 10:00 صباحاً - 2:00 ظهراً",
		notes: "برامج كرازة نشطة. التدريب متوفر. كرازة متعددة اللغات متاحة.",
		hasDuration: false,
		hasEnrollment: false,
		additionalInfo: "انضم لخطوط المقدمة في تقدم الملكوت من خلال قطاع الكرازة الديناميكي، حيث يصبح المؤمنون المتحمسون شهود أقوياء يجلبون النور للأماكن المظلمة. تجمع هذه الخدمة بين الكرازة الاستراتيجية في الشوارع والتوعية الرقمية المبتكرة للوصول للنفوس عبر جميع الديموغرافيات والمنصات. تعمل فرقنا الكرازية المدربة بقوة على تجهيز الشهود بالمواهب النبوية، والرؤى الإلهية، والشهادات الجذابة التي تخترق القلوب المتحجرة. من خلال برامج التدريب المنهجية، يتعلم المشاركون تقنيات الشهادة الفعالة، والدفاعيات، والكرازة عبر الثقافات، وتشغيل الخدمة الفائقة للطبيعة. توفر الوزارة موارد شاملة بما في ذلك الأدبيات الإنجيلية، والمحتوى الرقمي، ومواد المتابعة، وطرق الاتصال ببرامج التلمذة. تستهدف الفعاليات التوعوية المنتظمة الجامعات والأسواق والحدائق والمجتمعات عبر الإنترنت حيث تكون الأرواح الضائعة في أمس الحاجة إلى الأمل. يضمن نهجنا متعدد اللغات عدم وجود حاجز لغوي يمنع رسالة الإنجيل من الوصول إلى القلوب المستعدة. يختبر العديد من أعضاء الفريق اختراقات معجزية، ومواعيد إلهية، وتجارب فائقة للطبيعة أثناء الشهادة. هذه ليست مجرد كرازة للنفوس - إنها حرب روحية ضد الظلام، واختراق إقليمي للمجتمعات، واستعداد للحصاد الكبير الذي سيأتي على الأرض.",
		isActive: true
	}
];

// Export ministry data arrays for use in other modules  
export { MINISTRY_MOCK_DATA_EN, MINISTRY_MOCK_DATA_AR };

export const getMinistriesLocalized =(
	language: Language = Language.AR,
	fetchAll: boolean = false,
	page: number = 1,
	limit: number = 10
): PaginatedResult<Ministry> => {
	const ministries = language === Language.AR ? MINISTRY_MOCK_DATA_AR : MINISTRY_MOCK_DATA_EN;
	const actualLimit = fetchAll ? -1 : limit;
	const activeMinistries = ministries.filter(ministry => ministry.isActive);
	return PaginationUtil.paginate<Ministry>(activeMinistries, page, actualLimit);
};
